<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>应发全勤、打卡考核、旷工考核申诉</i></p>
          <div class="color999 pl24 mb20">请核对您的打卡数据，及时处理异常</div>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">请假天数</div>
              <div class="itemNum">{{form.leaveTotal}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">公休天数</div>
              <div class="itemNum">{{form.publicLeaveTotal}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">年假天数</div>
              <div class="itemNum">{{form.yearLeaveTotal}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">旷工天数</div>
              <div class="itemNum">{{form.noAttendanceTotal}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">缺卡次数</div>
              <div class="itemNum">{{form.absenceTotal}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">迟到<span v-if="otherForm.overtimeMinuteIn != 0">（{{otherForm.overtimeMinuteIn}}分钟以内）</span></div>
              <div class="itemNum">{{otherForm.overtimeTotalIn == 0 ? form.overtimeTotal : otherForm.overtimeTotalIn}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">早退<span v-if="otherForm.leaveEarlyMinuteIn != 0">（{{otherForm.leaveEarlyMinuteIn}}分钟以内）</span></div>
              <div class="itemNum">{{otherForm.leaveEarlyTotalIn == 0 ? form.leaveEarlyTotal : otherForm.leaveEarlyTotalIn}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">迟到<span v-if="otherForm.overtimeMinuteOut != 0">（{{otherForm.overtimeMinuteOut}}分钟以内）</span></div>
              <div class="itemNum">{{otherForm.overtimeTotalOut == 0 ? form.overtimeTotal : otherForm.overtimeTotalOut}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">早退<span v-if="otherForm.leaveEarlyMinuteOut != 0">（{{otherForm.leaveEarlyMinuteOut}}分钟以内）</span></div>
              <div class="itemNum">{{otherForm.leaveEarlyTotalOut == 0 ? form.leaveEarlyTotal : otherForm.leaveEarlyTotalOut}}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>请假管理</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">申请截止时间</div>
              <div class="itemNum">{{otherForm.leaveApplyEndTime}}<span class="gorequset ml20" @click="goProcess('/dataList/companyLeave')">去处理</span></div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>打卡异常</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">申请截止时间</div>
              <div class="itemNum">{{otherForm.attendanceAbnormalEndTime}}<span class="gorequset ml20" @click="goProcess('/dataList/abnormalAttendance')">去处理</span></div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>厨师补贴、收银补贴、副店长补贴</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">申请截止时间</div>
              <div class="itemNum">{{otherForm.subsidyApplyEndTime}}</div>
            </div>
            <div class="color999">这些类型的补贴金额与门店所有人的打卡情况相关，打卡数据变更后补贴金额会更新，请联系店长或后台人员协助处理。</div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>车费补贴、体检补贴、工服补贴、床品补贴、开业打扫补贴</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">申请截止时间</div>
              <div class="itemNum">{{otherForm.subsidyApplyEndTime}}<span class="gorequset ml20" @click="goProcess('/dataList/staffSubsidy')">去处理</span></div>
            </div>
            <div class="color999">这些类型的补贴金额以后台审核结果为准，如果您已经提交申请但是金额不准确，请联系后台人员协助处理。</div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>入职补助</i></p>
          <div class="totals-box pl24">
            <div class="color999">如果您的入职补助金额不准确，请先检查在入职补助期内是否有请假或旷工等情况，或咨询门店店长入职补助政策并联系后台人员协助处理。</div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>师带徒、品质战、爱心捐款、乐捐</i></p>
          <div class="totals-box pl24">
            <div class="color999">如果您的工资金额计算不准确，请联系后台人员协助处理。</div>
          </div>
          <div class="drawer-footer pr24 pb10">
            <el-button @click="back">返回</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: {
    drawer,
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "申诉",
      form: {
        leaveTotal: '',
      },
      otherForm: {}
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.userInfo = this.$store.getters.ShopInfo;
        this.getAttendanceInfo(org);
        this.getAppealInfo(org);
        this.addEditShow = true;
      });
    },
    getAttendanceInfo (org) {
      this.$api.get(this.$url.staffSalary.getAppealAttendanceInfo,{
        dataMonth: org
      }).then(res => {
        if (res) {
          this.form = res;
        }else {
          this.form = {};
        }
      }).catch(error => {});
    },
    getAppealInfo(org){
      this.$api.get(this.$url.staffSalary.getAppealInfo, {
        dataMonth: org,//this.$route.query.month
      }).then(res => {
        this.otherForm = res;
      }).catch(error => {});
    },
    goProcess (url) {
      this.$router.push(url);
      if (url == '/dataList/staffSubsidy') {
        this.$store.commit("setCurentUrls", url);
      } else {
        this.$store.commit("setCurentUrls", '/dataList/attendancePunch');
      }
      
    },
    back () {
      this.addEditShow = false;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.gorequset {
  padding: 0 5px;
  color: #3388FF;
  border: 1px solid #3388FF;
  border-radius: 2px;
  cursor: pointer;
}
</style>